import { render } from "./TheNavbarLink.vue?vue&type=template&id=3f100e23&scoped=true"
import script from "./TheNavbarLink.vue?vue&type=script&lang=js"
export * from "./TheNavbarLink.vue?vue&type=script&lang=js"

import "./TheNavbarLink.vue?vue&type=style&index=0&id=3f100e23&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f100e23"]])

export default __exports__